<template>
  <div :class="['asset_box', {'is_installed': installed}]">
    <p class="asset_box--store_name">{{sharedAsset.store_name}}</p>
    <h3 class="asset_box--label">{{label}}</h3>
    <p class="asset_box--description">{{sharedAsset.description}}</p>

    <button-outlined
        v-if="failedToInstall"
        class="asset_box--add_button"
        :disabled="true"
    >Failed to Install</button-outlined>

    <button-outlined v-else
      class="asset_box--add_button"
      :disabled="installing || installed"
      :loading="installing"
      @click="install"
    >{{ installed ? 'Already Installed' : 'Install'}}</button-outlined>

    <router-link
      v-if="installed"
      class="asset_box--link"
      :to="{name: 'settings', params: {tab: settingTab}}"
    >
      <template v-if="settingTab === 'pipeline'">Pipeline Settings</template>
      <template v-if="settingTab === 'followUp'">Follow Up Settings</template>
      <template v-if="settingTab === 'scripts'">Call Script Settings</template>
      <template v-if="settingTab === 'snippets'">Snippet Settings</template>
    </router-link>

    <div v-if="installed" class="asset_box--installed_check">
      <icon-default icon="check"></icon-default>
    </div>
  </div>
</template>

<script>
import {MODELS} from "../../../services/models";
import api from "../../../api";
import {appendModal} from "../../../services/modals";
import SelectStatusForSharableInstallModal from "./SelectStatusForSharableInstallModal";

export default {
  name: "StoreAssetBox",
  props: ['sharedAsset', 'settingTab'],
  data() {
    return {
      installed: false,
      failedToInstall: false,
      installing: false,
    }
  },
  created() {
    this.installed = this.sharedAsset.installed;
  },
  computed: {
    label() {
      if (this.sharedAsset.class_name === MODELS.PipelineView.class_name) {
        return this.sharedAsset.label;
      }
      if (this.sharedAsset.class_name === MODELS.FollowUpSequenceTemplate.class_name) {
        return this.sharedAsset.label;
      }
      if (this.sharedAsset.class_name === MODELS.Snippet.class_name) {
        return this.sharedAsset.label;
      }
      if (this.sharedAsset.class_name === MODELS.CallScript.class_name) {
        return this.sharedAsset.name;
      }
    },
  },
  methods: {
    callInstallApi(requestData) {
      this.installing = true;

      return api.shareableGroups.installSharedAsset(requestData).then((response) => {
        this.installed = true;
        this.installing = false;
        this.$emit('installed', this.sharedAsset);
      }).catch(() => {
        this.failedToInstall = true;
        this.installing = false;
      })
    },
    install() {
      let requestData = {
        ...this.sharedAsset,
        market_id: this.$store.state.market.market.id
      };

      if (this.sharedAsset.class_name === MODELS.CallScript.class_name) {
        let selectStatusModal = appendModal(SelectStatusForSharableInstallModal, this);
        selectStatusModal.$on('selectedStatus', (statusId) => {
          requestData.status_id = statusId;
          this.callInstallApi(requestData);
        });
      } else {
        this.callInstallApi(requestData);
      }

    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.asset_box {
  position: relative;
  padding: $modalGutter ($modalGutter * 2);
  background-color: $white;
  box-shadow: $box-shadow;

  &.is_installed {
    border: 2px solid $secondary;
  }

  &--store_name {
    color: $text-muted;
  }

  &--label {
    margin: 6px 0 12px;
    font-size: 1.375rem;
    color: $secondary;
    font-weight: bold;
  }

  &--count {
    font-size: 1.125rem;
    font-weight: 500;
  }

  &--description {
    margin-top: 8px;
    line-height: 1.4;
  }

  &--add_button {
    margin: 20px auto 10px;
  }

  &--view_button {
    margin: 0 auto;
  }

  &--link {
    display: block;
    margin: 20px auto 10px;
    font-size: 0.875rem;
    text-align: center;
  }

  &--installed_check {
    position: absolute;
    top: 0;
    right: 0;
    height: 30px;
    width: 30px;
    padding-top: 4px;
    padding-left: 2px;
    background-color: $secondary;
    color: $white;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 100%;
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-top: 30px solid $secondary;
    }

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 0;
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-top: 30px solid $secondary;
    }
  }
}
</style>
